<template>
  <avs-chip
    class="min-width-120"
    color="indigo"
    icon="mdi-check-all"
    iconColor="white"
    text-color="white"
  >
    {{ $t("Honorée") }}
  </avs-chip>
</template>

<script>
export default {
  name: "FulfilledChip",
};
</script>

<style scoped>
.min-width-120 {
  min-width: 120px;
}
</style>